import { FetchContext } from '../fetch-context';
import { responseErrorHandler } from '../response-error-handler';
import { AiScrubBatchLatestResponse, AiScrubScope } from '../../models';

export const getLatestAiScrubBatchRun: (
  fetchContext: FetchContext,
  awardId: number,
  accessToken?: string,
  scope?: AiScrubScope,
  countryId?: number,
) => Promise<AiScrubBatchLatestResponse | undefined> = (fetchContext, awardId, accessToken, scope = 'awards', countryId) => {
  // Country scope is keyed on a real country; never build the request with `?countryId=undefined`.
  // No country id means "no run to discover", so resolve empty rather than issue a malformed query.
  if (scope === 'country-awards' && typeof countryId !== 'number') {
    return Promise.resolve<AiScrubBatchLatestResponse | undefined>(undefined);
  }

  return fetch(`${fetchContext.baseUrl}/api/staff/${scope}/${awardId}/ai-scrub-batch/latest${scope === 'country-awards' ? `?countryId=${countryId}` : ''}`, {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
  })
  .then((response) => responseErrorHandler<AiScrubBatchLatestResponse | undefined>(fetchContext.errorStore, response, 'get latest AI scrub batch'));
};
